import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Stack,
    Alert,
    IconButton,
    InputAdornment
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function ChangePasswordModal({ open, handleClose, handleChangePassword }) {
    const [passwords, setPasswords] = useState({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });
    const [showPassword, setShowPassword] = useState({
        old: false,
        new: false,
        confirm: false
    });
    const [error, setError] = useState("");

    const handleChange = (field, value) => {
        setPasswords(prev => ({ ...prev, [field]: value }));
        setError(""); // Clear error on change
    };

    const handleClickShowPassword = (field) => {
        setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const onSave = () => {
        if (!passwords.oldPassword || !passwords.newPassword || !passwords.confirmPassword) {
            setError("All fields are required.");
            return;
        }

        if (passwords.newPassword !== passwords.confirmPassword) {
            setError("New passwords do not match.");
            return;
        }

        if (passwords.newPassword.length < 6) {
            setError("New password must be at least 6 characters long.");
            return;
        }

        handleChangePassword(passwords.oldPassword, passwords.newPassword);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ mb: 1 }}>Change Password</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    {error && <Alert severity="error">{error}</Alert>}

                    <TextField
                        fullWidth
                        label="Current Password"
                        type={showPassword.old ? "text" : "password"}
                        value={passwords.oldPassword}
                        onChange={(e) => handleChange("oldPassword", e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => handleClickShowPassword("old")}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword.old ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        fullWidth
                        label="New Password"
                        type={showPassword.new ? "text" : "password"}
                        value={passwords.newPassword}
                        onChange={(e) => handleChange("newPassword", e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => handleClickShowPassword("new")}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword.new ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        fullWidth
                        label="Confirm New Password"
                        type={showPassword.confirm ? "text" : "password"}
                        value={passwords.confirmPassword}
                        onChange={(e) => handleChange("confirmPassword", e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => handleClickShowPassword("confirm")}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword.confirm ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    disableElevation
                    sx={{
                        boxShadow: "none",
                        "&:hover": {
                            boxShadow: "none",
                            backgroundColor: "primary.main",
                            filter: "brightness(1.1)",
                        },
                    }}
                >
                    Change Password
                </Button>
            </DialogActions>
        </Dialog>
    );
}
